/** チャンネルイベント条件のトリガータイプ */
export type ExecTypeType = 'ADD' | 'CRON';
export const ExecTypeTypes: ExecTypeType[] = ['ADD', 'CRON'];
export function convertExecTypeType(s?: string, undef?: boolean) {
  for (const v of ExecTypeTypes) if (v === s) return s;
  return undef ? undefined : ExecTypeTypes[0];
}
